// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"96":"ForgotPasswordPage","267":"404Page","848":"ChangePasswordPage"}[chunkId] || chunkId) + "." + {"96":"c0cdce16","267":"6c983b39","787":"51555133","848":"b99d4bca"}[chunkId] + ".chunk.js";
};